export default {
  companies: [],
  partners: [],
  selectedCompany: {},
  selectedPartner: {},
  toggleDetailsModal: false,
  detailsModalConfig: {},
  companyGames: [],
  selectedGame: {},
  companyGameRounds: [],
  companyGameDetails: [],
  selectedRound: {},
  players: [],
  tags: [],
  assets: [],
  selectedAssetGame: {},
  bootstrap: {},
  reportsGames: [],
  selectedReportsGame: {},
  selectedPromotion: {},
  promotions: [],
  promotionPlayers: [],
  promotionDetails: [],
  reportsPlayers: [],
  rowsCount: [10, 25, 50, 100],
  thumbnail: process.env.VUE_APP_API_ASSETS,
  translations: undefined,
  pusherMessage: {},
  snackbarNotification: {},
  isMobile: false,
  toolbarTitle: '',
  acceptHeader: '',
  cancelControllers: [],
  loading: false,
  importFile: null,
  currencyValidation: {},
  promotionErrorList: {},
  unifiedCurrency: JSON.parse(localStorage.getItem('unifiedCurrency')),
  excludeInternal: JSON.parse(localStorage.getItem('excludeInternal')),
  gameAssetsDetails: {
    data: [],
    pagination: {},
  },
  uploadAssetsDialog: false,
  boostUrl: undefined,
  tournamentDetails: [],
  boostBootstrap: {},
  boostCompanies: [],
  boostUnavailable: false,
};
